import withTheme from './withTheme';
import React from 'react';
import { findKeyInObj } from '../../utils/objects';
import StyletronClient from 'styletron-client';
import { injectStyle } from 'styletron-utils';
import { noticeError } from 'app/api/analytics/reporting';
import { hexToCssRgba, mix } from '../../utils/color';
import { isEdge } from 'app/utils/browser';

const styletron = new StyletronClient();

function getRestProps(props) {
  const { component, render, children, dispatch, ...restProps } = props;
  return restProps;
}

function getStyleProps(props) {
  const { theme, mergeClasses, ...styleProps } = getRestProps(props);
  return styleProps;
}

const pseudo = [
  'before',
  'after',
  'hover',
  'focus',
  'active',
  'disabled',
  'placeholder',
];

function getKey(fullKey) {
  for (let i = 0; i < pseudo.length; i++) {
    if (fullKey.indexOf(pseudo[i]) === 0) {
      const prefixed = `:${pseudo[i]}`;
      if (pseudo[i] === 'placeholder') {
        if (isEdge()) {
          // https://github.com/styletron/styletron/issues/230
          return '::-webkit-input-placeholder';
        }
        return '::placeholder';
      }
      return prefixed;
    }
  }
  return fullKey;
}

function getStyle(fullKey, color, alpha = '1') {
  let char = alpha.charAt(0);
  let toMix = null;
  if (char === '-' || char === '+') {
    toMix = '#FFFFFF';
    if (parseFloat(alpha) < 0) {
      toMix = '#000000';
    }
  }

  const alphaNum = parseFloat(alpha);

  let colorVal = hexToCssRgba(color, alphaNum);
  if (toMix) {
    colorVal = mix(color, toMix, Math.abs(alphaNum) * 100);
  }

  for (let i = 0; i < pseudo.length; i++) {
    if (fullKey.indexOf(pseudo[i]) === 0) {
      let styleName = fullKey.split(pseudo[i])[1];
      styleName = styleName.charAt(0).toLowerCase() + styleName.slice(1);
      return {
        [styleName]: `${colorVal} !important`,
      };
    }
  }
  return `${colorVal} !important`;
}

class SimpleThemer extends React.Component {
  state = {
    key: null,
    classes: [],
  };

  static getDerivedStateFromProps = props => {
    if (!props.theme) {
      return [];
    }

    const styleProps = getStyleProps(props);
    const classes = Object.keys(styleProps)
      .map(cv => {
        if (cv && props[cv]) {
          const desiredStyle = findKeyInObj(props.theme, props[cv]);

          if (desiredStyle) {
            let [colorName, alpha] = desiredStyle.split('@');
            const color = props.theme.colors[colorName];
            if (color) {
              const key = getKey(cv);
              const style = getStyle(cv, color, alpha);
              try {
                return injectStyle(styletron, {
                  [key]: style,
                });
              } catch (e) {
                noticeError(
                  `Failed to inject style ${key} ${cv} ${
                    props[cv]
                  } ${JSON.stringify(style)}`
                );
                return null;
              }
            }
          }
        }
        if (props[cv]) {
          noticeError(`Missing Color: ${props[cv]}`);
        }
        return null;
      })
      .filter(e => e !== null);

    return {
      classes,
    };
  };

  render() {
    const allClasses = this.state.classes.concat(this.props.mergeClasses);
    const joinedClasses = allClasses.join(' ');

    if (this.props.render) {
      return this.props.render(joinedClasses);
    } else if (this.props.component) {
      return (
        <this.props.component className={joinedClasses}>
          {this.props.children}
        </this.props.component>
      );
    }
    return null;
  }
}

export default withTheme(SimpleThemer);
